<template>
  <Carousel
    v-bind="config"
    ref="myCarousel"
    @slide-start="onSlideStart"
    @update:model-value="onSlideChange"
  >
    <Slide v-for="slotId in slotIds" :key="slotId">
      <slot :name="slotId" />
    </Slide>
    <template #addons>
      <Navigation>
        <template #prev>
          <div class=" bgcolor-primary">
            <em class="arrow-fire primaryicon-left-arrow slick-arrow" style=' cursor: pointer; z-index: 1;'></em>
          </div>
          </template>
        <template #next>
          <em class="arrow-fire primaryicon-right-arrow bgcolor-primary _mitsubishi_background_color slick-arrow" style='cursor: pointer; z-index: 1;'></em>
        </template>
      </Navigation>
      <Pagination v-if="enablePagination"/>
    </template>
  </Carousel>
</template>

<script setup>
import "vue3-carousel/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";

const props = defineProps({
  config: {
    type: Object,
    required: true,
    default: () => ({
      wrapAround: true,
    }),
  },
  imagesData: {
    type: Array,
    required: true,
  },
  slotIds: {
    type: Array,
    required: false,
    default: () => [],
  },
  showArrows: {
    type: Boolean,
    required: false,
    default: false,
  },
  enablePagination: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const emit = defineEmits(["slideChange", "slideStart"]);

const onSlideChange = (currentSlide) => {
  emit("slideChange", currentSlide);
};

const onSlideStart = (data) => {
  emit("slideStart", data);
};
</script>

<style scoped>
.carousel__slide {
  display: block;
}
</style>
<style>
.carousel__prev, .carousel__next {
  outline: none !important;
}
em.primaryicon-right-arrow.slick-arrow {
  right: 20px !important;
  font-size: 18px !important;
}
em.primaryicon-left-arrow.slick-arrow {
  left: 20px !important;
  font-size: 18px !important;
}
</style>
